import { render, staticRenderFns } from "./characterSetToggle.vue?vue&type=template&id=b713d020&scoped=true"
import script from "./characterSetToggle.vue?vue&type=script&lang=js"
export * from "./characterSetToggle.vue?vue&type=script&lang=js"
import style0 from "./characterSetToggle.vue?vue&type=style&index=0&id=b713d020&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b713d020",
  null
  
)

export default component.exports